export enum ExceptionBackModelEnum {
  Technical = 1,
  Business = 2,
  ServiceDown = 3,
}
